import React, { useRef, useEffect, useState } from "react";
import ReactPlayer from "react-player";
import { useSelector, useDispatch } from "react-redux";
import {
  selectCurrentlyPlayingMatch,
  selectCurrentlyPlayingPoint,
  selectIsPlaying
} from "../store/videoPlayerSlice";
import { setIsPlaying, playNextShot } from "../store/videoPlayerSlice";
import { selectSelectedMatches } from "../store/matchesSlice";

const DoublesVideoPlayer = () => {
  const dispatch = useDispatch();
  const currentlyPlayingMatch = useSelector(selectCurrentlyPlayingMatch);
  const currentlyPlayingPoint = useSelector(selectCurrentlyPlayingPoint);
  const selectedMatches = useSelector(selectSelectedMatches);
  const isPlaying = useSelector(selectIsPlaying);
  const videoPlayerRef = useRef();
  const [playingPoint, setPlayingPoint] = useState(null);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (isReady && currentlyPlayingPoint) {
      videoPlayerRef.current.seekTo(currentlyPlayingPoint.startTime);
    }
  }, [isReady]);

  useEffect(() => {
    if (!currentlyPlayingPoint) {
      setPlayingPoint(currentlyPlayingPoint);
      return;
    }
    const isNextPoint = playingPoint && playingPoint.pointNumber === currentlyPlayingPoint.pointNumber + 1;
    if (!isNextPoint) {
      videoPlayerRef.current.seekTo(currentlyPlayingPoint.startTime);
    }
    setPlayingPoint(currentlyPlayingPoint);
  }, [currentlyPlayingPoint]);

  const HandlePlay = () => {
    dispatch(setIsPlaying(true));
  };

  const HandlePause = () => {
    dispatch(setIsPlaying(false));
  };

  const HandleProgress = (currentTime) => {
    if (!isPlaying || !currentlyPlayingPoint) {
      return;
    }
    if (currentTime > currentlyPlayingPoint.endTime) {
      dispatch(playNextShot());
    }
  };
  let config = { file: { attributes: { controlsList: "nodownload" } } };

  if (!currentlyPlayingMatch) {
    if (isReady) setIsReady(false);
    if(selectedMatches && selectedMatches.length === 0) {
      return (
        <div className="card vh-50 mb-3 align-items-center justify-content-center">
          <h4>No Video Is Selected</h4>
        </div>
      );
    }
    else {
      return (
        <div className="card vh-50 mb-3 align-items-center justify-content-center">
          <h4>No shots with this combination</h4>
        </div>
      );
    }
  }
  return (
    <div className="card vh-50 mb-3">
      <div className="card-header">
        <div>
          <h5 className="mb-0 mt-2 d-flex align-items-center justify-content-center">
            {`${currentlyPlayingMatch.firstTeamName} vs ${currentlyPlayingMatch.secondTeamName} - ${currentlyPlayingMatch.eventName}`}
          </h5>
        </div>
      </div>
      <div style={{ padding: 0 }} className="card-body">
        <div style={wrapperStyle}>
          <ReactPlayer
            ref={videoPlayerRef}
            config={config}
            playing={isPlaying}
            onPlay={() => HandlePlay()}
            onPause={() => HandlePause()}
            onProgress={(e) => HandleProgress(e.playedSeconds)}
            onReady={() => setIsReady(true)}
            controls={true}
            url={currentlyPlayingMatch.fullMatchVideoUrl}
            width="100%"
            height="100%"
          />
        </div>
      </div>
    </div>
  );
};

export default DoublesVideoPlayer;

const wrapperStyle = {
  position: "relative",
  width: "100%",
  height: "100%",
};

const overlayStyle2 = {
  position: "absolute",
  top: "80%",
  left: "40%",
  width: "20%",
  height: "12%",
  backgroundColor: "rgba(0,0,0,0.7)",
  zIndex: "1",
};
